import React from 'react';



// ── Icons ────────────────────────────────────────────────
export function GridIcon() {
  return <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.7"><rect x="2" y="2" width="7" height="7" rx="1.5"/><rect x="11" y="2" width="7" height="7" rx="1.5"/><rect x="2" y="11" width="7" height="7" rx="1.5"/><rect x="11" y="11" width="7" height="7" rx="1.5"/></svg>;
}
export function EditIcon() {
  return <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.7"><path d="M9 2H4a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-5"/><path d="M15 2l3 3-7 7H8v-3l7-7z"/></svg>;
}
export function ClockIcon() {
  return <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.7"><circle cx="10" cy="10" r="7"/><path d="M10 6v4l2.5 2.5"/></svg>;
}
export function BriefcaseIcon() {
  return <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.7"><rect x="2" y="5" width="16" height="12" rx="2"/><path d="M6 5V4a2 2 0 014 0v1M14 5V4a2 2 0 00-4 0v1"/><path d="M6 10h8M6 14h5"/></svg>;
}
export function StarIcon() {
  return <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.7"><polygon points="10,2 12.5,7.5 18,8 14,12 15.5,18 10,15 4.5,18 6,12 2,8 7.5,7.5"/></svg>;
}
export function TrophyIcon() {
  return <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.7"><path d="M5 2h10v6a5 5 0 01-10 0V2z"/><path d="M5 4H2v2a3 3 0 003 3M15 4h3v2a3 3 0 01-3 3"/><path d="M10 13v4M7 18h6"/></svg>;
}
export function MessageIcon() {
  return <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.7"><path d="M2 5a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2H7l-5 3V5z"/></svg>;
}
export function UserIcon() {
  return <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.7"><circle cx="10" cy="7" r="4"/><path d="M2 17a8 8 0 0116 0"/></svg>;
}
export function BellIcon() {
  return <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M10 2a6 6 0 016 6c0 5 2 7 2 7H2s2-2 2-7a6 6 0 016-6z"/><path d="M8 17a2 2 0 004 0"/></svg>;
}
export function SunIcon() {
  return <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="10" cy="10" r="3"/><path d="M10 2v1M10 17v1M2 10h1M17 10h1M4.22 4.22l.7.7M15.08 15.08l.7.7M15.08 4.92l-.7.7M4.22 15.78l.7-.7"/></svg>;
}
export function SearchIcon({ color = "currentColor" }) {
  return <svg width="14" height="14" viewBox="0 0 20 20" fill="none" stroke={color} strokeWidth="2"><circle cx="9" cy="9" r="6"/><path d="M15 15l3 3"/></svg>;
}

export function MoonIcon() {
  return <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M17.29 13.59A8 8 0 119.41 1.7a6.5 6.5 0 007.88 11.89z"/></svg>;
}
export function DbIcon() {
  return <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8"><ellipse cx="10" cy="5" rx="8" ry="3"/><path d="M2 5v10c0 1.66 3.58 3 8 3s8-1.34 8-3V5"/><path d="M2 10c0 1.66 3.58 3 8 3s8-1.34 8-3"/></svg>;
}
export function ApiIcon() {
  return <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M13 10h5l-5 5"/><path d="M7 10H2l5-5"/><path d="M10 2v16"/></svg>;
}
export function ShieldIcon() {
  return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>;
}
export function CodeIcon() {
  return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>;
}
export function LayersIcon() {
  return <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>;
}
export function TrendingUpIcon({ size = 14, color = "currentColor" }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>;
}

export const NAV = [
  {
    section: "Overview",
    items: [
      { id: "dashboard",    label: "Dashboard", icon: <GridIcon /> },
      { id: "tests",        label: "Tests & Challenges",   icon: <EditIcon /> },
      { id: "results",      label: "My Results",  icon: <ClockIcon /> },
      { id: "jobs",         label: "Job Opportunities", icon: <BriefcaseIcon /> },
    ],
  },
  {
    section: "Progress",
    items: [
      { id: "leaderboard",  label: "Leaderboard",  badge: null,               icon: <StarIcon /> },
      { id: "achievements", label: "Achievements", badge: null,               icon: <TrophyIcon /> },
    ],
  },
];

export const STATS = [
  { num: "12",   label: "Tests Passed" },
  { num: "03",   label: "Saved Jobs" },
  { num: "24",   label: "Skills Verified" },
  { num: "08",   label: "Applications" },
];

export const TESTS = [
  { name: "UI Architecture Challenge",      company: "G-Scale",   time: "45m", xp: "850 XP",  diff: "Hard" },
  { name: "Node.js Backend & Scaling",     company: "SkyData",   time: "60m", xp: "1200 XP", diff: "Hard" },
  { name: "React Optimizations Quiz",      company: "TechFlow",  time: "30m", xp: "450 XP",  diff: "Medium" },
];

export const RECENT = [
  { name: "Frontend Master",    company: "Amazon",  passed: true },
  { name: "API Security",       company: "Netflix",  passed: true },
  { name: "Database Design",    company: "Microsoft",  passed: false },
  { name: "AWS Cloud Basics",   company: "Google",  passed: true },
];

export const JOBS = [
  { initials: "NF", name: "Lead UX Engineer",      company: "Netflix",   salary: "$180k - $220k", match: 94, color: "#e50914", bg: "rgba(229,9,20,0.1)" },
  { initials: "GT", name: "Senior Web Developer",  company: "GitLab",    salary: "$140k - $170k", match: 89, color: "#fc6d26", bg: "rgba(252,109,38,0.1)" },
  { initials: "SC", name: "Frontend Architect",    company: "SoundCloud", salary: "$130k - $155k", match: 82, color: "#ff3300", bg: "rgba(255,51,0,0.1)" },
];
